import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=58b3ad7c&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=58b3ad7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b3ad7c",
  null
  
)

export default component.exports